<form [formGroup]="form" (ngSubmit)="save()">
    <span class="float-end">
        <button [disabled]="saving" type="submit" class="btn btn-primary" [disabled]="!form.valid" i18n>Save</button>&nbsp;
        <button [disabled]="saving" type="button" class="btn btn-danger" [disabled]="!adsCampaign.id" (click)="delete()"
            i18n>Delete</button>&nbsp;
        <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown"><fa-icon [icon]="fa.faEllipsis"></fa-icon></button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><button type="button" class="dropdown-item" (click)="copy()" i18n>Copy</button></li>
        </ul>
    </span>
    <h3 *ngIf="adsCampaign.id" class="mt-3"><span i18n>Campaign:</span> {{ adsCampaign.name }}</h3>
    <h3 *ngIf="!adsCampaign.id" class="mt-3" i18n>New campaign</h3>

    <ng-container *ngIf="adsCampaign.id">
        Created: {{ adsCampaign.created_at | date: 'short' }} {{ adsCampaign.created_by.first_name }} {{
        adsCampaign.created_by.last_name }} &bullet;
        Modified: {{ adsCampaign.updated_at | date: 'short' }} {{ adsCampaign.updated_by.first_name }} {{
        adsCampaign.updated_by.last_name }}
    </ng-container>

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="setFragment($event)" class="nav-tabs mt-3">
        <li [ngbNavItem]="'basics'">
            <button ngbNavLink i18n>Basics</button>
            <ng-template ngbNavContent>
                <div class="row g-3">
                    <div class="col-4">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="name" formControlName="name"
                                    autocomplete="off">
                            </div>
                            <div class="col-12">
                                <label for="organizations" class="form-label" i18n>Country</label>
                                <select class="form-select" id="organization_id" formControlName="organization_id">
                                    <option [ngValue]="null" i18n>Select country</option>
                                    <option *ngFor="let organization of organizations | localeSort: 'country'"
                                        [ngValue]="organization.id">{{ organization.country }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="status" class="form-label" i18n>Status</label>
                                <select class="form-select" id="status" formControlName="status">
                                    <option *ngFor="let status of adsCampaignStatuses | keyvalue"
                                        [ngValue]="status.key">{{ status.value }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="start_date" class="form-label" i18n>Dates</label>
                                <div class="input-group">
                                    <input type="date" class="form-control" id="start_date" formControlName="start_date">
                                    <span class="input-group-text">-</span>
                                    <input type="date" class="form-control" id="end_date" formControlName="end_date">
                                </div>
                            </div>
                            <div class="col-12">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th i18n>City</th>
                                            <th i18n>Radius</th>
                                            <th class="text-end">
                                                <button [disabled]="!adsCampaign.id" (click)="areaEdit()" type="button"
                                                    class="btn btn-primary btn-sm" i18n>Add</button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let area of adsCampaign.areas">
                                            <td class="align-middle">{{ area.city }}</td>
                                            <td class="align-middle">{{ area.radius }} km</td>
                                            <td class="align-middle text-end">
                                                <button (click)="areaEdit(area)" type="button"
                                                    class="btn btn-primary btn-sm" i18n>Edit</button>&nbsp;
                                                <button (click)="areaDelete(area)" type="button"
                                                    class="btn btn-danger btn-sm" i18n>Remove</button>
                                            </td>
                                        </tr>
                                        <tr *ngIf="adsCampaign.areas.length == 0">
                                            <td colspan="3" class="text-center fst-italic" i18n>Targetting whole country
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-12">
                                <label class="form-label" i18n>Targetting description</label>
                                <textarea rows="5" class="form-control"
                                    formControlName="targeting_description"></textarea>
                                <div class="text-muted small" i18n>Describe the product or service you are promoting
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label" i18n>Cutoff</label>
                                <div class="input-group">
                                    <input type="range" class="form-control form-range" formControlName="cutoff" min="0" max="1" step="0.01">
                                    <span class="input-group-text">{{ form.value.cutoff | number: '1.2-2' }}</span>
                                </div>
                                <div class="text-muted small" i18n>The cutoff score for the examples</div>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-primary btn-sm float-end" (click)="loadExamples()" type="button"
                                    i18n>Update</button>
                                <label class="form-label" i18n>Examples of targeted orders</label>

                                <div *ngFor="let example of examples" class="card">
                                    <div class="card-body">
                                        <div class="fw-bold">
                                            {{ example.match_score * 100 | number: '1.0-0' }}% &bull;
                                            {{ example.assignment.name }} &bull; 
                                            {{ example.start | date: 'EEEE' }} {{ example.start | date: 'shortDate' }}
                                        </div>
                                        <div style="white-space: pre-wrap;">{{ example.ad_summary }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <button [disabled]="!adsCampaign.id" class="btn btn-primary btn-sm float-end"
                            (click)="assetEdit()" type="button" i18n>Create</button>
                        <label class="form-label" i18n>Assets</label>
                        <div *ngFor="let adsCampaignAsset of adsCampaign.assets" class="card mb-3">
                            <div class="card-body">
                                <div class="card-body cursor-pointer p-0" (click)="assetEdit(adsCampaignAsset)">
                                    <div class="d-flex align-items-top">
                                        <img [src]="adsCampaignAsset.picture"
                                            style="width: 3rem; height: 3rem; border-radius: 50%; object-fit: cover; object-position: center;"
                                            class="me-3">
                                        <div>
                                            <div class="text-info fw-bold">{{ adsCampaignAsset.ads_organization.display_name }}
                                            </div>
                                            <div style="white-space: pre-wrap;">{{ adsCampaignAsset.content }}</div>
                                        </div>
                                    </div>
                                    <div class="w-100 bg-light rounded p-2 py-1 mt-3 text-black row g-1">
                                        <div class="col-12" i18n>Placement:</div>
                                        <ng-container  *ngFor="let placement of adsCampaignAssetPlacements | keyvalue" class="col-3 small">
                                            <div *ngIf="adsCampaignAsset[placement.key]">
                                                {{ placement.value }}
                                            </div>
                                        </ng-container>
                                        <div class="col-12"><span i18n>Bid:</span> {{ adsCampaignAsset.bid | number: '1.2-2' }} €</div>
                                        <div class="col-12" i18n>Link:</div>
                                        <div class="col-12 small">{{ adsCampaignAsset.url }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!adsCampaign.id" class="card">
                            <div class="card-body">
                                <div class="card-body d-flex align-items-center justify-content-center text-muted" i18n>
                                    Save campaign first</div>
                            </div>
                        </div>
                        <div *ngIf="adsCampaign.id && adsCampaign.assets.length == 0" class="card">
                            <div class="card-body">
                                <div class="card-body d-flex align-items-center justify-content-center text-muted">
                                    <a href="javascript:void(0)" (click)="assetEdit()" i18n>Create your first asset</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="my-3"></div>
</form>